// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';

// Hooks
import useNotificationRead from '../../hooks/useNotificationRead';

// Component
import Template from '../../components/Template';

// Images
import img from '../../../sass/images/company/vehicle-registration.svg';

// Utils
import { contactEmail, contacNumber } from '../../helpers';

function VehicleRegistration(props) {
  const { newMaintenancesCompany } = useNotificationRead();
  const { t } = props;
  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      <>
        <div className="content_dynamic history block-job-requests">
          <Row className="content_maintenace">
            <div className="header-content">
              <div className="info-tittle">
                <h1 className="title-maintenances">{t('tittle')}</h1>
              </div>
            </div>
          </Row>
          <Row>
            <Col sm={12}>
              <div className="not-services">
                <img src={img} className="img-not-maintenances" alt={t('alt:vehicle')} />
                <h4 className="center txt-20 txt1">{t('text1')}</h4>
                <p className="center txt-16 txt2">
                  {t('text2')} {contacNumber()} {t('text3')}
                  <a href={`mailto:${contactEmail()}`}>
                    <strong> {contactEmail()}. </strong>
                  </a>
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </>
    </Template>
  );
}
VehicleRegistration.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation(['vehicle', 'alert', 'alt'])(VehicleRegistration);
